import React from 'react';
import { Typography } from 'antd';
import { useResponsiveSizes } from '../../../hooks/use-responsive-sizes';
import { tokens } from '../../../theme/tokens';

const { Title } = Typography;

interface PageTitleProps {
  children: React.ReactNode;
  style?: React.CSSProperties;
}

export const PageTitle: React.FC<PageTitleProps> = ({ children, style }) => {
  const { fontSize, spacing } = useResponsiveSizes();

  return (
    <Title
      level={1}
      style={{
        fontSize: fontSize.xxxl,
        marginBottom: spacing.xs,
        display: 'flex',
        fontWeight: 500,
        color: tokens.colors.primary.neutral[1030],
        ...style
      }}
    >
      {children}
    </Title>
  );
};
